/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

const template = [
  {
    id: uuidV4(),
    index: "1",
    title: "Tổng số người lao động",
    bg: false,
    spendId: 16,
    value: 0,
  },
  {
    id: uuidV4(),
    isTitle: false,
    spendId: 17,
    value: 0,
    title: "Trong đó: Cá nhân cư trú có hợp đồng lao động",
  },
  {
    id: uuidV4(),
    index: "2",
    spendId: 18,
    value: 0,
    title: "Trong số cá nhân đã khấu trừ thuế [18]=[19]+[20]",
  },
  {
    id: uuidV4(),
    index: "2.1",
    spendId: 19,
    value: 0,
    title: "Cá nhân cư trú",
  },
  {
    id: uuidV4(),
    index: "2.2",
    spendId: 20,
    value: 0,
    title: "Cá nhân không cư trú",
  },
  {
    id: uuidV4(),
    index: "3",
    spendId: 21,
    value: 0,
    title: "Tổng số cá nhân thuộc diện được miễn, giảm thuế theo Hiệp định tránh đánh thuế hai lần",
  },
  {
    id: uuidV4(),
    index: "4",
    spendId: 22,
    value: 0,
    title: "Tổng số cá nhân giảm trừ gia cảnh",
  },
  {
    id: uuidV4(),
    index: "5",
    spendId: 23,
    value: 0,
    title: "Tổng thu nhập chịu thuế tra cho cá nhân [23]=[24]+[25]",
  },
  {
    id: uuidV4(),
    index: "5.1",
    spendId: 24,
    value: 0,
    title: "Cá nhân cư trú",
  },
  {
    id: uuidV4(),
    index: "5.2",
    spendId: 25,
    value: 0,
    title: "Cá nhân không cư trú",
  },
  {
    id: uuidV4(),
    index: "5.3",
    spendId: 26,
    value: 0,
    title:
      "Trong đó: Tổng thu nhập chịu thuế từ tiền phí mua bảo hiểm nhân thọ, bảo hiểm không bắt buộc khác của doanh nghiệp bảo hiểm không thành lập tại Việt Nam cho người lao động",
  },
  {
    id: uuidV4(),
    index: "6",
    spendId: 27,
    value: 0,
    title: "Trong đó tổng thu nhập chịu thuế được miễn theo quy định của Hợp đồng dầu khí",
  },
  {
    id: uuidV4(),
    index: "7",
    spendId: 28,
    value: 0,
    title:
      "Trong tổng thu nhập chịu thuế trả cho cá nhân thuộc diện phải khấu trừ thuế [28]=[29]+[30]",
  },
  {
    id: uuidV4(),
    index: "7.1",
    spendId: 29,
    value: 0,
    title: "Cá nhân cư trú",
  },
  {
    id: uuidV4(),
    index: "7.2",
    spendId: 30,
    value: 0,
    title: "Cá nhân không cư trú",
  },
  {
    id: uuidV4(),
    index: "8",
    spendId: 31,
    value: 0,
    title: "Tổng số thuế thu nhập cá nhân đã khấu trừ [31]=[32]+[33]",
  },
  {
    id: uuidV4(),
    index: "8.1",
    spendId: 32,
    value: 0,
    title: "Cá nhân cư trú",
  },
  {
    id: uuidV4(),
    index: "8.2",
    spendId: 33,
    value: 0,
    title: "Cá nhân không cư trú",
  },
  {
    id: uuidV4(),
    index: "8.3",
    spendId: 34,
    value: 0,
    title:
      "Trong đó: Tổng số thuế thu nhập cá nhân đã khấu trừ trên tiền phí mua bảo hiểm nhân thọ, bảo hiểm không bắt buộc khác của doanh nghiệp bảo hiểm hiểm không thành lập tại Việt Nam cho người lao động",
  },
];

function TaxPersonalTable({ setFieldValue }) {
  const [data, setData] = useState(template);

  useEffect(() => {
    setFieldValue("valuesTableII", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, type } = values;
    console.log({ id, name, value, type });
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value };
        }
        return item;
      })
    );
  };

  const isBg = (index) => {
    return [16, 17, 18, 21, 22, 23, 27, 28, 31].includes(index);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Mã chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Đơn vị tính
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số người/Số tiền
              </Td>
            </tr>
            {data.map((item) => {
              return (
                <tr key={item.id}>
                  {item.spendId !== 17 && (
                    <Td
                      rowSpan={item.spendId === 16 ? 2 : 1}
                      style={{
                        textAlign: "center",
                        background: item.spendId > 17 ? "#ddeff3" : "transparent",
                        fontWeight: isBg(item.spendId) ? "bold" : "400",
                      }}
                    >
                      {item.index}
                    </Td>
                  )}
                  <Td
                    style={{
                      textAlign: "left",
                      maxWidth: 400,
                      background: item.spendId > 17 ? "#ddeff3" : "transparent",
                      fontWeight: isBg(item.spendId) || item.index === "1" ? "bold" : "400",
                    }}
                  >
                    {item.title}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background: item.spendId > 17 ? "#ddeff3" : "transparent",
                      fontWeight: "bold",
                    }}
                  >
                    [{item.spendId}]
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background: item.spendId > 17 ? "#ddeff3" : "transparent",
                    }}
                  >
                    {item.spendId > 20 ? "VNĐ" : "Người"}
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      paddingRight: item.spendId > 17 ? 20 : 8,
                      background: item.spendId > 17 ? "#ddeff3" : "transparent",
                      fontWeight: isBg(item.spendId) ? "bold" : "400",
                    }}
                  >
                    {item.spendId > 17 ? (
                      0
                    ) : (
                      <InputTable
                        id={item.id}
                        name="value"
                        value={item.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(TaxPersonalTable);

function InputTable(props) {
  const { id, onChange, type = "text", name, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
